<template>
  <div>
    <div class="site-header-wrap"  @click="isShowSearch = false">
      <header class="header">
        <div class="logo_box">
          <img
            class="logo_img"
            src="../../assets/image/logo.png"
            alt
            @click="$router.push({ path: '/' })"
          />
          <!-- <div class="logo_txt">修正药业</div> -->
        </div>
        <nav>
          <div :class="['navList',isShowSearch&&'nav_hide']">
            <div
              class="nav_item"
              v-for="(item, i) in navList"
              :key="i"
              :class="pathName == item.name ? 'active' : ''"
              @click="goNav(item.name)"
            >
              {{ item.title }}
            </div>
          </div>
        </nav>
      </header>
      <div :class="['hearder_search',isShowSearch&&'hearder_search_hide']">
        <div v-if="!isShowSearch" class="store_wrap">
        <div class="store">
          <div class="shopStore" @click="goToStore">
            <img
            @mouseenter="enter"
            @mouseleave="leave"
              class="shopping_img"
              :src="shopping_icon"
              alt
            />
            <div class="txt">在线购买</div>
          </div>
        </div>
        <div class="search_icon">
          <img
            class="img"
            @click.stop="isShowSearch = true"
            @mouseenter="enter1"
            @mouseleave="leave1"
            :src="search_icon"
            alt
          />
        </div>
      </div>
      <div class="serch_box" v-else @click.stop.prevent>
        <div class="srch_item">
          <input
            type="text"
            placeholder="请输入搜索关键词"
            v-model.trim="searchValue"
            autofocus
            @keydown.enter="goSearch()"
          />
          <img
            class="img"
            @click="goSearch()"
            src="../../assets/image/search_logo.png"
            alt
          />
        </div>
        <img
          class="close"
          @click="searchClose"
          src="../../assets/image/search_close.png"
          alt
        />
      </div>
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      navList: [
        { title: "走进修正", path: "/", name: "index" },
        { title: "新闻中心", path: "/pressCenter", name: "pressCenter" },
        { title: "科技研发", path: "/research", name: "research" },
        { title: "集团产品", path: "/groupProducts", name: "groupProducts" },
        {
          title: "党团建设",
          path: "/partyConstruction",
          name: "partyConstruction",
        },
        { title: "人力资源", path: "/humanResource", name: "humanResource" },
        { title: "爱心修正", path: "/loveXiuZheng", name: "loveXiuZheng" },
        { title: "关于我们", path: "/about", name: "about" },
      ],
      searchValue: "",
      isShowSearch: false,
      shopping_icon:require("../../assets/image/shopping.png"),
      search_icon:require('../../assets/image/search_logo.png')
    };
  },
  props:{
    isClose:{
        type:Boolean,
        default:false
      },
  },
  computed: {
    pathName() {
      return this.$route.name;
    },
  },
  methods: {
    goToStore(){// 去商城
         window.open('https://www.xzcare.com/#/')
    },
    searchClose() {
      this.isShowSearch = false;
    },
    goNav(name) {
      this.$router.push({
        name: name,
      });
    },
    getValue(e) {
      console.log(e.target.value);
    },
    goSearch() {
      console.log(this.searchValue);
      this.$router.push({
        path: "./searchResult",
        query: {
          searchValue: this.searchValue,
        },
      });
      this.$store.dispatch("seachFn", this.searchValue);
      console.log(this.getSearchval);
    },
    enter(){
      this.shopping_icon=require("../../assets/image/hover_shopping.png")
    },
    leave(){
      this.shopping_icon=require("../../assets/image/shopping.png")
    },
    enter1(){
      this.search_icon=require("../../assets/image/hover_search_logo.png")
    },
    leave1(){
       this.search_icon=require('../../assets/image/search_logo.png')
    }
  },
  mounted() {
    this.searchValue = "";
  },
  watch:{
    isClose: {
      //小于5滚动停止
      deep: true,
      handler(newVal) {
        console.log(1111111,newVal
        );
        this.isShowSearch = false
      },
    },
  }
};
</script>

<style scoped lang="stylus">
.site-header-wrap {
  height: 76px;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.05), 0px 1px 0px 0px #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 80px;
  .header {
    display: flex;
    align-items: center;

    .logo_box {
      margin-right: 288px;
      display: flex;
      align-items: center;

      .logo_img {
        width: 122px;
        height: 34px;
        margin-right: 8px;
        cursor: pointer;
      }
    }

    .navList {
      display: flex;
      overflow: visible;
      transition: all 0.3s;
      .nav_item {
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
        color: #333333;
        margin-right: 38px;

        &:nth-last-of-type(1) {
          margin: 0px;
        }

        &:hover {
          color: #014EA2;
          cursor: pointer;
          // font-weight: bold;
        }
      }

      .active {
        color: #014EA2;
        cursor: pointer;
        // font-weight: bold;
      }
    }
    .nav_hide{
      transform: scale(0);
      visibility: hidden;
      transition: all 0.5s;
     }
  }
  .hearder_search{
    width:fit-content;
  }
  .hearder_search_hide{
    width: fit-content;
  }
    .store_wrap{
      display :flex;
      justify-content :flex-end
      align-items center
      transition all  1s
      .store {
    background: #F5F5F5;
    border-radius: 20px;
    padding: 0px 19px 0 23px;
    height: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;

    // .img {
    // width: 18px;
    // height: 18px;
    // }
    .shopStore {
      display: flex;

      .shopping_img {
        width: 20px;
        height: 20px;
      }

      .txt {
        margin-left: 6px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #333333;
        line-height: 19px;
        text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.05);
      }
      .txt:hover{
        color:#014EA2;
      }
    
    }
  }

  .search_icon {
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-left: 20px;
      margin-top: 3px;
    }
  }


    }
.serch_box {
    display: flex;
    align-items: center;
    justify-content:flex-end
    transition: all 0.3s;
    transform-origin: 100% center;
    background-color: #fff;
    z-index: 100;
    width: 500px;
    height: 40px;
    right: 8px;
    transform: scale(1);
    .srch_item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor pointer;
      input {
        width: 100%;
        height: 40px;
        border: 1px solid #d4d4d4;
        line-height: 40px;
        padding-left: 20px;
        outline: none;
        font-size: 16px;
        background-color: #fff;
      }

      ::-webkit-input-placeholder {
        color: gray;
        font-size: 12px;
      }

      .img {
        position: absolute;
        right: 10px;
        width: 20px;
        height: 20px;
      }
    }

    .close {
      width: 20px;
      height: 20px;
      margin-left: 20px;
      cursor pointer;
    }
  }

}
</style>
